// extracted by mini-css-extract-plugin
module.exports = {"Avatar":"miPgfQ"};